import React, { useState, useEffect, useRef } from 'react'
import { Box, InputAdornment, TextField } from '@mui/material'
import { Email, LockClockOutlined } from '@mui/icons-material'
import cloneDeep from 'lodash/cloneDeep'
import Reaptcha from 'reaptcha'
import { toast } from 'react-toastify'

import { ValidateEmail } from 'utils/validators'
import { requestRecoverPassword } from 'services/apiAuth'
import { ROUTE_CONSTANTS } from 'utils/constants/routeConstants'
import { gotoUrl } from 'utils/functions'
import { Button } from '../../../components'

import styles from './styles'

const PasswordRecover = () => {
  const classes = styles()
  const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY
  const captcha = useRef()

  const [formValues, setFormValues] = useState({
    email: '',
  })

  const [loading, setLoading] = useState(false)
  const [validEmail, setValidEmail] = useState(false)
  const [validCaptcha, setValidCaptcha] = useState(false)

  const handleChange = (event) => {
    const { name, value } = event.target
    const updatedFormValues = cloneDeep(formValues)
    updatedFormValues[name] = value
    setValidEmail(ValidateEmail(value))
    setFormValues(updatedFormValues)
  }

  const onRenderCaptcha = () => {
    captcha.current.execute()
  }

  const validateCaptcha = () => {
    setValidCaptcha(true)
  }

  const expiredCaptcha = () => {
    captcha.current.reset()
    captcha.current.execute()
    setValidCaptcha(true)
  }

  const handleSubmit = async () => {
    const data = { email: formValues.email }
    setLoading(true)

    try {
      const response = await requestRecoverPassword(data)
      if (response.status === 200) {
        gotoUrl(ROUTE_CONSTANTS.EMAIL_SENT)
      }
    } catch (error) {
      toast.error(`Erro: ${error?.response?.data?.detail}`)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    setValidCaptcha(false)
    captcha.current.execute()
  }, [])

  const canSend = validEmail && validCaptcha

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <div className={classes.titleBar}>
          <div className={classes.locker}>
            <LockClockOutlined fontSize="inherit" />
          </div>
          <h1 className={classes.title}>Esqueceu sua senha?</h1>
          <h3 className={classes.subtitle}>
            Por favor, informe o e-mail associado à sua conta para enviarmos um
            link com instruções de recuperação de acesso:
          </h3>
        </div>

        <Box
          component="form"
          className={classes.formBox}
          noValidate
          autoComplete="on"
        >
          <TextField
            required
            fullWidth
            name="email"
            label="Email"
            value={formValues.email}
            onChange={handleChange}
            type="text"
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Email />
                </InputAdornment>
              ),
            }}
          />

          <Button loading={loading} onClick={handleSubmit} disabled={!canSend}>
            Enviar e-mail de recuperação
          </Button>
        </Box>
      </div>

      <Reaptcha
        ref={captcha}
        sitekey={RECAPTCHA_SITE_KEY}
        onVerify={validateCaptcha}
        onExpire={expiredCaptcha}
        onRender={onRenderCaptcha}
        size="invisible"
        badge="inline"
      />
    </div>
  )
}

export default PasswordRecover
